export type CandidatesTranslations = {
  columns: {
    areas: string;
    candidate: string;
    decisionDue: string;
    quizFinished: string;
    score: string;
    status: string;
    statusChanged: string;
    studies: string;
  };
  filters: {
    area: string;
    clear: string;
    decisionFrom: string;
    decisionTo: string;
    location: string;
    score: string;
  };
  noResults: string;
  overdue: string;
  profile: {
    about: string;
    activeTime: string;
    areas: string;
    categories: string;
    close: string;
    fair: string;
    fieldOfStudy: string;
    finished: string;
    justification: string;
    language: string;
    loadError: string;
    location: string;
    minutes: string;
    no: string;
    noQuiz: string;
    points: string;
    quiz: string;
    registered: string;
    skillLevels: string[];
    skills: string;
    skillTypes: Record<string, string>;
    started: string;
    studentStatus: string;
    studies: string;
    timeline: string;
    typeOfStudy: string;
    under30: string;
    university: string;
    yearOfStudy: string;
    yes: string;
  };
  quickFilters: {
    afterQuiz: string;
    all: string;
    fromFair: string;
    inProgress: string;
    negative: string;
    onHold: string;
    positive: string;
    stopped: string;
  };
  search: string;
  sortBy: string;
  timeLeft: string;
  timelineEvents: Record<string, string>;
  title: string;
};

export const candidatesTranslations: CandidatesTranslations = {
  columns: {
    areas: 'Obszary',
    candidate: 'Kandydat',
    decisionDue: 'Decyzja do',
    quizFinished: 'Quiz ukończony',
    score: 'Wynik',
    status: 'Status',
    statusChanged: 'Ostatnia zmiana',
    studies: 'Uczelnia i miejsce stażu',
  },
  filters: {
    area: 'Obszar',
    clear: 'Wyczyść filtry',
    decisionFrom: 'Decyzja od',
    decisionTo: 'Decyzja do',
    location: 'Miejsce stażu',
    score: 'Wynik quizu',
  },
  noResults: 'Brak kandydatów spełniających kryteria',
  overdue: 'termin minął',
  profile: {
    about: 'O sobie',
    activeTime: 'Czas w quizie',
    areas: 'Obszary zainteresowań',
    categories: 'Wyniki w kategoriach',
    close: 'Zamknij',
    fair: 'Targi pracy',
    fieldOfStudy: 'Kierunek',
    finished: 'Ukończony',
    justification: 'Dlaczego te obszary (słowami kandydata)',
    language: 'Język kandydata',
    loadError: 'Nie udało się pobrać profilu kandydata.',
    location: 'Miejsce stażu',
    minutes: '{{value}} min',
    no: 'nie',
    noQuiz: 'Kandydat nie rozpoczął jeszcze quizu.',
    points: 'Punkty',
    quiz: 'Quiz',
    registered: 'Rejestracja',
    skillLevels: ['nie zna', 'początkujący', 'podstawowy', 'dobry', 'zaawansowany'],
    skills: 'Samoocena kompetencji',
    skillTypes: {
      LANGUAGE: 'Języki',
      PROGRAMMING_LANGUAGE: 'Języki programowania',
      SYSTEM_TECHNOLOGY_METHODOLOGY: 'Systemy, technologie i metodyki',
      TOOL: 'Narzędzia',
    },
    started: 'Rozpoczęty',
    studentStatus: 'Status',
    studies: 'Studia',
    timeline: 'Historia procesu',
    typeOfStudy: 'Rodzaj studiów',
    under30: 'Poniżej 30 lat',
    university: 'Uczelnia',
    yearOfStudy: 'Rok studiów',
    yes: 'tak',
  },
  quickFilters: {
    afterQuiz: 'Po quizie',
    all: 'Wszyscy',
    fromFair: 'Z targów',
    inProgress: 'W trakcie',
    negative: 'Negatywni',
    onHold: 'Wstrzymani',
    positive: 'Pozytywni',
    stopped: 'Przerwani',
  },
  search: 'Szukaj po nazwisku, e-mailu lub telefonie',
  sortBy: 'Sortuj według: {{column}}',
  timeLeft: 'zostało {{time}}',
  timelineEvents: {
    ACCOUNT_CREATION: 'Utworzenie konta',
    ADMIN_DOWNLOAD_FULL_AUDIT: 'Admin pobrał pełny audyt',
    ADMIN_DOWNLOAD_PROCESS_DETAILS: 'Admin pobrał plik procesu',
    ADMIN_POSITIVE_FEEDBACK_CHANGE: 'Admin zmienił decyzję na pozytywną',
    ADMIN_SET_NEGATIVE_FEEDBACK: 'Admin ustawił decyzję negatywną',
    ADMIN_SET_ON_HOLD: 'Admin wstrzymał decyzję',
    CANDIDATE_SENT_TO_ALL_EXTERNAL_RECRUITMENTS: 'Przekazanie do eRecruitera',
    EMAIL_SENT_ADMIN_FAIR_CANDIDATE_QUIZ_FINISHED: 'Powiadomienie adminów: kandydat z targów',
    EMAIL_SENT_ADMIN_LOGIN: 'E-mail z logowaniem do panelu',
    EMAIL_SENT_ADMIN_ON_HOLD_REMINDER: 'Powiadomienie adminów: przypomnienie o wstrzymaniu',
    EMAIL_SENT_CANDIDATE_BACK_TO_APP_ACTIVE_PROCESS_NOT_ON_QUIZ: 'E-mail: powrót do aplikacji',
    EMAIL_SENT_CANDIDATE_BACK_TO_APP_QUIZ_EXPIRED: 'E-mail: czas quizu minął',
    EMAIL_SENT_CANDIDATE_BACK_TO_QUIZ: 'E-mail: powrót do quizu',
    EMAIL_SENT_CANDIDATE_END_OF_PROCESS: 'E-mail: zgłoszenie przyjęte',
    EMAIL_SENT_CANDIDATE_LACK_OF_ACTIVITY: 'E-mail: przypomnienie o braku aktywności',
    EMAIL_SENT_CANDIDATE_NOT_ACTIVE_PROCESS_FEEDBACK_SENT: 'E-mail: proces zakończony',
    EMAIL_SENT_CANDIDATE_NOT_ACTIVE_PROCESS_WAITING_FOR_FEEDBACK: 'E-mail: czekamy na decyzję',
    EMAIL_SENT_CANDIDATE_ON_HOLD_NEEDS_MORE_TIME: 'E-mail: potrzebujemy więcej czasu',
    EMAIL_SENT_CANDIDATE_ONBOARDING: 'E-mail powitalny',
    EMAIL_SENT_NEGATIVE_FEEDBACK: 'E-mail z negatywną informacją zwrotną',
    EMAIL_SENT_POSITIVE_FEEDBACK: 'E-mail z pozytywną informacją zwrotną',
    other: 'Zdarzenie',
    PERSONAL_DATA_WITH_AREA_OF_INTEREST_SUBMISSION: 'Wysłanie danych i obszarów zainteresowań',
    PERSONAL_DATA_WITH_AREA_OF_INTEREST_UPDATE: 'Zmiana danych i obszarów zainteresowań',
    QUIZ_FINISHED: 'Ukończenie quizu',
    QUIZ_INITIALIZATION: 'Rozpoczęcie quizu',
    QUIZ_SUBMISSION: 'Wysłanie quizu',
    SKILLS_ASSESSMENT_SUBMISSION: 'Samoocena kompetencji',
    USER_LOGGED_IN: 'Logowanie',
  },
  title: 'Kandydaci',
};
